import _ from 'lodash'

export function getAddressComponent(gmaps, type) {
  const component = _.find(gmaps.address_components, ({ types }) =>
    _.find(types, t => t === type)
  )
  if (component) {
    return component.long_name
  }
  return ''
}
